import { Link } from 'react-router-dom';
import CookieBanner from './CookieBanner';
import { useState, useEffect } from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <footer className="bg-dark text-white relative overflow-hidden">
        {/* Background Watermark */}
        <div className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none">
          <div className="font-display font-black text-[120px] lg:text-[180px] text-white">
            BIOTRAUMA
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center mb-6">
                <img
                  src="https://public.readdy.ai/ai/img_res/a636c02b66d6d3f98ff640285b0b644c.jpg"
                  alt="BIOTRAUMA Logo"
                  className="h-16 w-auto"
                  loading="lazy"
                  decoding="async"
                  width="64"
                  height="64"
                />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                Servicio profesional de <strong>limpieza post mortem</strong> en <strong>Barcelona</strong> y provincia. Discreción, profesionalidad y respeto en cada intervención.
              </p>
              <div className="flex space-x-4">
                <a
                  href="tel:+34629501941"
                  className="w-10 h-10 flex items-center justify-center bg-primary/10 text-primary rounded-full hover:bg-primary hover:text-white transition-colors cursor-pointer"
                  aria-label="Llamar"
                >
                  <i className="ri-phone-line text-lg"></i>
                </a>
                <a
                  href="mailto:info@postmorten.biotrauma.es"
                  className="w-10 h-10 flex items-center justify-center bg-primary/10 text-primary rounded-full hover:bg-primary hover:text-white transition-colors cursor-pointer"
                  aria-label="Email"
                >
                  <i className="ri-mail-line text-lg"></i>
                </a>
                <a
                  href="https://wa.me/34629501941"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-primary/10 text-primary rounded-full hover:bg-primary hover:text-white transition-colors cursor-pointer"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                </a>
              </div>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="font-display font-semibold text-lg mb-6 text-white">Páginas</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-gray-400 hover:text-primary transition-colors text-sm">
                    Inicio
                  </Link>
                </li>
                <li>
                  <Link to="/empresa" className="text-gray-400 hover:text-primary transition-colors text-sm">
                    Empresa
                  </Link>
                </li>
                <li>
                  <Link to="/servicios" className="text-gray-400 hover:text-primary transition-colors text-sm">
                    Servicios
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="text-gray-400 hover:text-primary transition-colors text-sm">
                    Preguntas Frecuentes
                  </Link>
                </li>
                <li>
                  <Link to="/contacto" className="text-gray-400 hover:text-primary transition-colors text-sm">
                    Contacto
                  </Link>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-display font-semibold text-lg mb-6 text-white">Servicios</h4>
              <ul className="space-y-3">
                <li className="text-gray-400 text-sm">
                  <i className="ri-check-line text-primary mr-2"></i>
                  Limpieza Post Mortem
                </li>
                <li className="text-gray-400 text-sm">
                  <i className="ri-check-line text-primary mr-2"></i>
                  Desinfección Profesional
                </li>
                <li className="text-gray-400 text-sm">
                  <i className="ri-check-line text-primary mr-2"></i>
                  Neutralización de Olores
                </li>
                <li className="text-gray-400 text-sm">
                  <i className="ri-check-line text-primary mr-2"></i>
                  Retirada de Enseres
                </li>
                <li className="text-gray-400 text-sm">
                  <i className="ri-check-line text-primary mr-2"></i>
                  Preparación para Entrega
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-display font-semibold text-lg mb-6 text-white">Contacto</h4>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <i className="ri-map-pin-line text-primary text-lg mt-0.5 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-400 text-sm">
                    Plaça de Julio González, 8<br />
                    Sant Martí, 08005 Barcelona
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-phone-line text-primary text-lg w-5 h-5 flex items-center justify-center"></i>
                  <a href="tel:+34629501941" className="text-gray-400 hover:text-primary transition-colors text-sm cursor-pointer">
                    +34 629 501 941
                  </a>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-mail-line text-primary text-lg w-5 h-5 flex items-center justify-center"></i>
                  <a href="mailto:info@postmorten.biotrauma.es" className="text-gray-400 hover:text-primary transition-colors text-sm cursor-pointer break-all">
                    info@postmorten.biotrauma.es
                  </a>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-time-line text-primary text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-400 text-sm">
                    Disponible 24/7
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-16 pt-8 border-t border-gray-800">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-gray-500 text-sm text-center md:text-left">
                © {currentYear} BIOTRAUMA POST MORTEM. Todos los derechos reservados.
              </div>
              <div className="flex flex-wrap justify-center md:justify-end items-center gap-6 text-sm">
                <Link to="/aviso-legal" className="text-gray-500 hover:text-primary transition-colors">
                  Aviso Legal
                </Link>
                <Link to="/privacidad" className="text-gray-500 hover:text-primary transition-colors">
                  Privacidad
                </Link>
                <Link to="/cookies" className="text-gray-500 hover:text-primary transition-colors">
                  Cookies
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <CookieBanner />
      
      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 left-6 w-14 h-14 bg-primary text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all duration-300 z-40 cursor-pointer"
          aria-label="Volver arriba"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
        </button>
      )}
    </>
  );
};

export default Footer;
